import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

import { CommonModalData } from '../types';
import { EPageType } from './types';
import { detailsValidationSchema } from './validation';

type Props = {
  stepData: CommonModalData['data'];
  initialType?: EPageType;
};

const useDetailsForm = ({ stepData, initialType }: Props) => {
  const defaultType = stepData.details?.type;

  const defaultValues = defaultType ? { type: defaultType as EPageType } : { type: initialType };

  const methods = useForm<{ type: EPageType }>({
    defaultValues,
    resolver: yupResolver(detailsValidationSchema),
    mode: 'all',
  });

  return { ...methods };
};

export { useDetailsForm };
